<template>
  
<div v-if="isExisting" class="modal-card" id="IndexPage">
  <header class="modal-card-head">
    <p v-if="isLocked" class="modal-card-title">Hey - you've already bought this book...</p>
    <p v-else class="modal-card-title">Hey - you've already made this book...</p>
  </header>
  <section class="modal-card-body">
    <div class="content">
      <div>
        <h2 id="projectTitle" class="title" v-if="project.title">{{project.title}}</h2>
        <h2 id="projectSite" class="title" v-else><em>{{project.site}}</em></h2>
      </div>
    </div>
    
    <div v-if="isLocked" id="statusBox">
      <p>You can no longer modify this book but if you want to make
      changes or create a new volume then you can <i>Duplicate</i> it
      into a new book from your
      <router-link to="/mybooks">MyBooks</router-link> page.</p>
      <p>Otherwise, please proceed to view the book and purchase
      additional copies.</p>
    </div>
    <div v-else id="statusBox">
      <p></p>
      <p>If you want to <i>Refresh</i> this book from your {{blogBranding.brand}} or <i>Duplicate</i>
      it into a new book then you can perform these Actions from your
      <router-link to="/mybooks">MyBooks</router-link> page.</p>
      <p>Otherwise, please proceed to view the book and purchase.</p>
    </div>
    <signup-card v-if="showSignUp" :message="signupMessage"></signup-card>
  </section>

  <footer class="modal-card-foot">
    <div class="level">
      <div class="level-left"> </div>
        <div class="level-right">
          <button class="button" type="button" @click="cancel">Cancel</button>
          <button class="button" type="button" @click="gotoMyBooks">Go to MyBooks</button>
          <button class="button is-primary"
                  @click="openProject">View Book<span v-if="!isSignedIn">&nbsp;as Guest</span></button>
        </div>
      </div>
  </footer>
</div>

<div v-else class="modal-card" id="IndexPage">
  
  <header class="modal-card-head">
    <p v-if="isRefresh" class="modal-card-title">Refreshing book content from your {{blogBranding.brand}}...</p>
    <p v-else-if="requiresAuthByUrl" class="modal-card-title">Let us see your {{blogBranding.content}}!</p>
    <p v-else-if="isPhotoBook" class="modal-card-title"> Proceed to create photobook</p>
    <p v-else class="modal-card-title">One minute while we analyse your {{blogBranding.brand}}.</p>
    <button v-if="requiresAuthByUrl" class="delete" @click="cancel">X</button>
  </header>
  
  <section class="modal-card-body">
    <b-notification v-if="isBroken" has-icon :closable="false">
      <h3>Sorry! Instagram is Broken!</h3>
      <p><b>Long Version:</b>
        At short notice, Instagram has disabled their interface that
        allows you to share your content with us (and indeed all other
        parties). So your content is locked up in Instagram. We are
        trying to find a way around it but this may take some
        time. Meanwhile, it's broke :-(
      </p>
    </b-notification>

    <div v-if="!requiresAuthByUrl && !isPhotoBook && (taskState=='busy' || taskState=='error' || taskState=='success')" class="content">
      <div>
        <h2 id="projectTitle" class="title" v-if="project.title">{{project.title}}</h2>
        <h2 id="projectSite" class="title" v-else><em>{{project.site}}</em></h2>
      </div>
    </div>
    
    <div id="statusBox">
      
      <b-notification v-if="taskState=='pending' || (isPhotoBook && taskState=='busy')" has-icon :closable="false">
        <h3 v-if="isPhotoBook">Checking authorization...</h3>
        <h3 v-else>Waiting for indexer...</h3>
      </b-notification>
      
      <div v-else-if="requiresAuthByUrl"
           :closable="false">
        <div class="auth-link">
          <b-button class="auth-button"
                  size="is-large" type="is-primary" outlined
                  @click="showAuthWindow(authUrl)">
            <div class="level">
              <img v-if="blogBranding.icon" width="40" height="40" :src="blogBranding.icon"
                   style="vertical-align: center;"/>
              <span>&nbsp;&nbsp; Connect to {{blogBranding.brand}}</span>
            </div>
          </b-button>
        </div>

        <ul>
        <li>This will open a new window with the {{blogBranding.brand}} authorization page.</li>
        <li>There, select <b><u>Allow</u></b> to share your photos with PixxiBook.</li>
        </ul>
        
        <p><center style="font-size: 125%;">We need this to build your book!</center></p>
        <p><i>Problems? Make sure your browser allows popup windows from
            PixxiBook.<br>
            Check <router-link to="/doc/print-an-instagram-album#auth">this
        guide</router-link> or contact us
        at <a href="mailto:support@pixxibook.com">support@pixxibook.com</a></i></p>
      </div>

      <b-message v-else-if="taskState=='error'" type="is-danger"
                 has-icon :closable="false"
                 :title="errorExplanation.title">
        <p><span v-html="errorExplanation.message"></span>
          <span v-if="errorExplanation.link">More
            details <router-link :to="errorExplanation.link">here</router-link>.</span></p>
        <p>{{errorExplanation.action}} If the error persists, please
          contact us
          at <a href="mailto:support@pixxibook.com">support@pixxibook.com</a>
          and we'll get the pixxies onto it ASAP.</p>
      </b-message>
      
      <b-notification class="box" v-else-if="taskState=='busy' && !isPhotoBook"
                      :closable="false">
        <div v-if="totalItems > 0 && posts.length == totalItems">
          <div class="loader"></div> Checking for new posts...
        </div>
        <div v-else>
          <div class="loader"></div><span v-if="isRefresh">Refreshing</span><span v-else>Indexing</span>...
          <progress class="progress" :value="posts.length" :max="totalItems"></progress>
          {{photoAlbumCount || posts.length}} of {{totalItems}}
        </div>
      </b-notification>
      
      <b-notification v-else-if="taskState=='success'" type="is-success" has-icon :closable="false">
        <h3 v-if="isPhotoBook">Ready!</h3>
        <h3 v-else-if="isRefresh">Ready: scanned {{taskResult.postsScanned}} posts,
          {{taskResult.postsNew}} new, {{taskResult.postsChanged}} changed.
        </h3>
        <h3 v-else>Ready: found
          <span v-if="photoAlbumCount">{{photoAlbumCount}} albums</span>
          <span v-else>{{posts.length}} posts</span>
        </h3>
        <div v-if="successExplanation">
          <div v-html="successExplanation"></div>
          <br>Please contact us at <a href="mailto:support@pixxibook.com">support@pixxibook.com</a>
          for more information.
        </div>
      </b-notification>
      
    </div>
    <signup-card v-if="showSignUp" :message="signupMessage"></signup-card>
  </section>
  
  <footer class="modal-card-foot" v-if="!requiresAuthByUrl">
    <div class="level">
      <div class="level-left"> </div>
        <div class="level-right">
          <button class="button" type="button" @click="cancel">Back</button>
          <button class="button is-primary"
                  :disabled="taskState != 'success'"
                  @click="openProject">Continue<span v-if="!isSignedIn">&nbsp;as Guest</span></button>
        </div>
      </div>
   </footer>

</div>
</template>

<script>
import SignupCard from '@/components/SignupCard'
import Firebase from '../firebase.js'
import Tasker from '../tasker.js'
import ActionLog from '../actionlog.js'
var db = Firebase.database
const MAX_POSTS_LIMIT = 2000

var BLOG_BRANDING_DEFAULT = { tag: 'blog', brand: 'blog', content: 'posts', icon: '' }
var BLOG_BRANDINGS = {
  // these are used for oath dialogs
  instagram: { tag: 'instagram', brand: 'Instagram', content: 'posts', icon: '/static/instagram-logo-128.webp' },
  google: { tag: 'google', brand: 'Google Photos', content: 'photos', icon: '/static/googlephotos-logo-128.webp' },
  // just for detection of tag
  squarespace: BLOG_BRANDING_DEFAULT,
  UNKNOWN: BLOG_BRANDING_DEFAULT,
}

export default {
  name: 'IndexPage',
  components: {
    SignupCard,
  },
  data () {
    return {
      task: undefined,
      isRefresh: false,
      isExisting: false,
      isLocked: false,
      projid: undefined,
      authResult: undefined,
      authWindow: undefined,
      aphotoSource: undefined,
    }
  },
  props: {
    site: {type: String},
    projectid: {type: String},
    tag: {type: String},
  },
  computed: {
    user: function() {
      return this.$store.state.user
    },
    blogBranding: function() {
      //some weirdness here about this.site not having toLowerCase
      // despite being type "string"
      const url = (this.site+'').toLowerCase()
      for (const k in BLOG_BRANDINGS) {
        if (url.includes(k)) {
          BLOG_BRANDINGS[k].tag = k
          return BLOG_BRANDINGS[k]
        }
      }
      return BLOG_BRANDINGS['UNKNOWN']
    },
    isSignedIn: function() {
      return this.$store.state.isSignedIn
    },
    isPhotoBook: function() {
      return this.blogBranding.tag == 'google'
    },
    showSignUp: function() {
      return !this.isSignedIn
        && !this.requiresAuthByUrl
        && (this.taskState == 'error'
            //|| this.taskState == 'busy'
            || this.taskState == 'success')
    },
    taskDesc: function() {
      if (this.task && this.task.desc) {
        return this.task.desc
      }
      return {} //this.task.data.desc
    },
    taskState: function() {
      if (this.task && this.task.desc) {
        return this.task.desc.state
      }
      return 'init'
    },
    taskResult: function() {
      return this.taskDesc['result']
    },
    requiresAuthByUrl: function() {
      return this.taskState == 'error' && this.task.desc.error.authUrl
    },
    authUrl: function() {
      if (this.requiresAuthByUrl) {
        return this.task.desc.error.authUrl
      }
      return ''
    },
    totalItems: function() {
      if (this.project && this.project.feed &&
          this.project.feed.totalItems) {
        return this.project.feed.totalItems
      }
      return this.photoAlbumCount || 100
    },
    errorExplanation: function() {
      var errmsg = this.task.desc.error.message
      var detail = this.task.desc.error.detail || 'NO_DETAIL'
      var authUrl = this.task.desc.error.authUrl
      var message = undefined
      var link = undefined
      var blogType = 'blog'
      var title = 'Something\'s gone wrong!'
      var action = 'Please check your _BLOG_TYPE_ URL and try again.'

      if (authUrl) {
        title = 'Further Authorization Required'
        message = 'SHOULDNT GET HERE'
        action = 'Instagram support is brand new, so we would love to hear about your experience.'
      } else if (detail.includes('service not known')
          || detail.includes('Failed to establish a new connection')) {
        message = 'Invalid blog address - this is not a reachable address.'
      } else if (detail.includes('Unable to connect')) {
        message = 'Invalid blog address - this isn\'t a valid page.'
      } else if (detail.includes('Invalid travelark blog address')) {
        message = 'Invalid blog address - travelark addresses should look like http://www.travelark.org/travel-blog/username/1 and must be Version 2'
      } else if (detail.includes('Invalid instagram user')) {
        message = 'Invalid or unknown username - account address should look like https://instagram.com/username'
        blogType = 'account'
      } else if (detail.includes('private instagram')) {
        message = 'Cannot access private Instagram account. Make your account public temporarily and retry.'
        blogType = 'account'
      } else if (detail.includes('accounts.google.com')) {
        if (detail.includes('blogger.com/blog/posts/')
                  || detail.includes('blogger.com/u/')) {
          message = 'This looks like a link to your blogger account rather than your blog.'
            + ' Please provide your blog\'s public address.'
        } else {
          message = 'Cannot access private blog. Please set your blog\'s <i>Reader Access</i> setting to <i>Public</i>.'
          link = '/doc/print-a-blogger-blog#private'
        }
      } else if (detail.includes('/wp-login')
                 || detail.includes('private')) {
        message = 'Cannot access private blog.'
      } else if (detail.includes('Cannot find RSS')) {
          message = 'Cannot find RSS feed for this blog - maybe it is disabled in your blog settings?'
      } else if (detail.includes('unknown cms')) {
        if (detail.includes('wordpress.com/view/')
            || detail.includes('wordpress.com/home/')
            || detail.includes('wordpress.com/posts/')) {
          message = 'This looks like a link to your wordpress account rather than your blog.'
            + ' Please provide your blog\'s public address.'
        } else if (detail.includes('blogger.com/blog/posts/')
                   || detail.includes('blogger.com/u/')) {
          message = 'This looks like a link to your blogger account rather than your blog.'
            + ' Please provide your blog\'s public address.'
        } else if (detail.includes('instagram.com/')) {
          message = 'No content found. Maybe the account is private.'          
          blogType = 'account'
        } else {
          message = 'No content found. Maybe the blog is private or is on an unsupported service.'
        }
      }

      if (!message && errmsg) {
        if (errmsg.includes('no posts')
            && this.blogBranding.tag == 'squarespace') {
          message = 'No posts found.'
            + '  Note that you need to use the address of'
            + ' the blog part of your squarespace post,'
            + ' for example <i>myname.squarespace.com/blog</i.>'
        } else {
          message = 'Apparently: "'+errmsg +'".';
        }
      }

      if (!message) {
        message = 'We\'re having some mysterious trouble with this.'
      }

      action = action.replace('_BLOG_TYPE_',blogType)
      return { message, link, action }
    },
    successExplanation: function() {
      if (this.posts.length < this.totalItems
          && this.posts.length == MAX_POSTS_LIMIT) {

        return `<p>We have indexed the most recent ${MAX_POSTS_LIMIT}
                posts. If you wish us to index the entire back catalog
                then please contact us for assistance.<p>`

      } else if ((this.project.feed.feedurl || '').search('feeds.feedburner.com') >= 0) {

        return `<p>Sorry - feedburner RSS feeds are unsupported. You
                will probably encounter some missing posts and other
                content issues.</p>  <p>You can disable the feedburner
                plugin in your blog settings and try again (anyway,
                there is no real need for feedburner these days).</p>`

      } else if (!this.project.feed.cms) {

        return `<p>This is an incomplete result for an unsupported blog
                host. You will probably encounter some missing posts and
                other content issues.</p>  <p>PixxiBook currently
                supports: Blogger, Wordpress (including self-hosted),
                Squarespace, Wix and Tumblr.  We are working on more hosts.</p>`

      }
      return ''
    },
    signupMessage: function() {
      if (this.task) {
        switch (this.taskState) {
          case 'error': 
          return "<p>Something's gone wrong!</p> <p>Sign in and we will let you know when we've fixed it.</p>"
        }
      }

      return `<p>Now we're doing some work!</p>
              <p>Please sign in/up. This will ensure that you can always
              get back to your book later. You privacy is protected - we
              will never spam you or share your details with anyone
              (except when necessary to fulfil an order).</p>`
    },
    photoSource: function() {
      if (this.project
          && this.project.feed
          && this.project.feed.gpinstance) {
        if (!this.aphotoSource) {
          console.log('SOURCE DETECTED:', this.project.feed.gpinstance)
          this.$bindAsObject('aphotoSource',
                             db.ref('/photosources/'+this.$store.state.uid+'/'+this.project.feed.gpinstance+'/albums'))
        }
      }
      return this.aphotoSource
    },
    photoAlbumCount: function() {
      return Object.keys(this.photoSource || {}).length
    },
    isBroken: function() {
      return false //this.site.indexOf('nstagram.com') > 0 && this.site.indexOf('?_') < 0
    },
  },
  watch: {
    taskState: function(newState) {
      if (newState == 'error' && this.task.desc.error.authUrl) {
        //this.showAuthWindow(this.task.desc.error.authUrl)
      }
    },
  },
  methods: {
    refreshAll: function(authCode) {
      var desc = { project: this.projid,
                   updateMeta: true,
                   postFrom: 0, postCount: MAX_POSTS_LIMIT }
      if (authCode) {
        desc.authCode = authCode
      }
      if (this.site.includes('photos.google')) {
        desc.photoOp = { cmd: 'check-auth',
                         sourceId: 'te' }
        this.task = Tasker.createTask('mediaer', desc)
      } else {
        this.task = Tasker.createTask('indexer', desc)
      }
    },
    openProject: function() {
      if (this.photoSource) {
        this.$router.push("/photobook/"+this.projid)
      } else {
        this.$router.push("/projects/"+this.projid)
      }
    },
    cancel: function() {
      if (this.task) {
        this.task.cancel()
      }
      console.log("cancel", this.$parent, this.$parent.name)
      this.$parent.close()
    },
    gotoMyBooks: function() {
      this.cancel()
      this.$router.push('/mybooks')
    },
    showAuthWindow: function(url) {
      console.log('show auth window', url)
      this.authResult = undefined
      window.addEventListener('message', this.receiveAuthMessage)
      
      var width = 700, height = 580
      var w = window.outerWidth - width, h = window.outerHeight - height
      var left = Math.round(window.screenX + (w / 2))
      var top = Math.round(window.screenY + (h / 2.5))
      const specs = `width=${width},height=${height},left=${left},top=${top},toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,type=popup`
      this.authWindow = window.open(url, 'pixxi_auth_popup_'+this.task.desc.params.project, specs)
      ActionLog('oauth_req', { projid: this.projid,
                               isBlocked: !this.authWindow,
                               userAgent: navigator.userAgent })
      if (!this.authWindow) { 	
      }
      this.pollAuthWindow()
    },
    pollAuthWindow: function() {
      if (this.authWindow) {
        if (this.authWindow.closed) {
          console.log('auth window was closed')
          ActionLog('oauth_closed', {projid: this.projid})
          this.authWindow = undefined
          this.authResult = 'Authorization failed to complete (window closed). Please cancel and retry.'
        } else {
          setTimeout(this.pollAuthWindow, 500);
        }
      }
    },
    receiveAuthMessage: function(ev) {
      const rsp = ev.data.args
      console.log('got auth message:', ev.data)
      if (ev.data.pixxi == 'oauth_result' && rsp) {
        if (rsp.code) {
          ActionLog('oauth_ok', {projid: this.projid})
          this.refreshAll(rsp.code)
        } else if (rsp.error == 'access_denied') {
          ActionLog('oauth_err', {projid: this.projid})
          this.authResult = 'Authorization was refused ('+rsp.error_reason+')'
        }
        this.authWindow = undefined
      }
    },
  },
  beforeMount: function() {
    if (this.isBroken) {
      return
    }
    
    var protolesssite = this.site.trim().replace(/^https?:\/\//ig, "")
    var cleanedsite = protolesssite.replace(/\/+$/, '')
    this.projid = this.projectid || encodeURIComponent(cleanedsite).replace(/[\.\#\$\[\]\\\/&\?%]/g,"_")
    console.log('indexing',cleanedsite,'as',this.projid)
    var proj = db.ref("/projects/"+this.$store.state.uid+"/"+this.projid)
    this.$bindAsObject("project", proj)
    var posts = db.ref("/projects/"+this.$store.state.uid+"/"+this.projid+"/posts")
    this.$bindAsArray("posts", posts)
    
    proj.once("value", snap => {
      var projinfo = snap.val()
      
      if (projinfo // there's a record already
          && projinfo.posts!==undefined // invalidated record
          && !projinfo.isDeleted //not deleted
          && (!projinfo.selections || !projinfo.selections.isDeleted) //not deleted
         ) {
        if (this.projectid) {
          ActionLog('refresh', {projid: this.projid})
          this.isRefresh = true
          this.refreshAll();
        } else {
          this.isLocked = projinfo.isLocked
          this.isExisting = true
        }
      } else {
        if (projinfo) {
          if (projinfo.posts===undefined) {
            console.log("recreating invalid project", cleanedsite)
          } else if (projinfo.isDeleted || (projinfo.selections && projinfo.selections.isDeleted)) {
            console.log("recreating ex-deleted project", cleanedsite)
          }
        }
        console.log("a new project", cleanedsite)
        ActionLog('create', {projid: this.projid})
        proj.set({ site: cleanedsite,
                   posts: {},
                   createStamp: { ".sv" : "timestamp" } })
        try {
          this.$ga.event('Conversions', 'CreateBook', this.tag || this.$route.path)
        } catch (error) {
          console.error(error)
        }
        this.refreshAll();
      }
    });
  },
  beforeDestroy: function() {
    window.removeEventListener('message', this.receiveAuthMessage)
  },
}
</script>


<style scoped>
.loader {
    display: inline-block;
}
.level {
    width: 100%;
}
.button {
    min-width: 8em;
}
.title, h3, section { /*counteract .hero.is-dark */
    color: #363636 !important;
}

.modal-card-title {
    margin-bottom: 0 !important;
}
.auth-link {
    width: 100%;
    text-align: center;
    margin-bottom: 1em;
}
.auth-button {
    min-width: 80%;
    padding: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/IndexPage.vue